module.exports = __webpack_public_path__ + "img/works2_active.df9316b8.png";